var _rect, _rect2, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinusButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 23,
    height: 23,
    rx: 1.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 23,
    height: 23,
    rx: 1.5,
    stroke: "#8C8C8C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9201 17.5H7.62749L11.3661 7.31818H12.6388L16.3775 17.5H15.0849L12.0423 8.92898H11.9627L8.9201 17.5ZM9.39737 13.5227H14.6076V14.6165H9.39737V13.5227Z",
    fill: "#8C8C8C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7731_28098)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "translate(5 5.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.625 11.9062H6.375C6.30625 11.9062 6.25 11.9625 6.25 12.0313V12.9688C6.25 13.0375 6.30625 13.0938 6.375 13.0938H17.625C17.6938 13.0938 17.75 13.0375 17.75 12.9688V12.0313C17.75 11.9625 17.6938 11.9062 17.625 11.9062Z",
    fill: "#8C8C8C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7731_28098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusButton);
export default __webpack_public_path__ + "static/media/minusButton.daa409965daf33f53eb96b90a5621bfe.svg";
export { ForwardRef as ReactComponent };